
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import lodash from 'lodash'
import { EnumMyAccountPacksFilter } from '@xt/client/enums/my'
import { myAccountPacksFilter } from '@xt/client/dataSource/my/index'

@Component({})
export default class ExchangeTabsComp extends Vue {
  tabPane: Array<{
    key: EnumMyAccountPacksFilter
    title: string
  }> = myAccountPacksFilter

  defaultActiveKey: number = EnumMyAccountPacksFilter.All
  activeKey: number = +lodash.get(this.$route.query, 'active', EnumMyAccountPacksFilter.All)

  @Emit('change')
  tabsChange(activeKey: string) {
    if (this.activeKey === +activeKey) return

    this.activeKey = +activeKey

    return this.activeKey
  }
}
